import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service';
import { Observable } from 'rxjs';
import { Dossier } from '../dossier';

@Injectable({
  providedIn: 'root'
})
export class DossierService extends WSService<Dossier> {

  constructor() { super("dossier");}

  setPhase(id_dossier,id_phase,state,note):Observable<any>{
    return Globals.ws.requestUrl("dossier","setPhase",[id_dossier,id_phase,state,note]);
  }

  getLog(id_dossier):Observable<any>{
    return Globals.ws.requestUrl("dossier","getLog",[id_dossier]);
    
  }

  updateLog(log,returnid){

    var item2db:any=log;
    if(Globals.ws.api_version=="v2")
      item2db={"values":log}

    return Globals.ws.send("dossier","updateLog",item2db,[],(result)=>{returnid(result);});

  }

}
